import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Alert, Box, Chip, CircularProgress, IconButton, Paper, Stack, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";

const API_ROOT = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export default function MyNotificationsList() {
  const [alerts, setAlerts] = useState([]);
  const [meta, setMeta] = useState({ deviceCount: 0, ownerUser: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const activeCount = useMemo(() => alerts.filter((alert) => alert?.checked !== false).length, [alerts]);
  const load = useCallback(async () => {
    const token = localStorage.getItem("token") || localStorage.getItem("authToken");
    if (!token) {
      setError("Login token missing hai. Dobara login karke try karo.");
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError("");
      const response = await axios.get(`${String(API_ROOT).replace(/\/+$/, "")}/users/my-alerts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAlerts(Array.isArray(response?.data?.alerts) ? response.data.alerts : []);
      setMeta({ ownerUser: response?.data?.ownerUser || null, deviceCount: Number(response?.data?.deviceCount || 0) });
    } catch (requestError) {
      setAlerts([]);
      setMeta({ deviceCount: 0, ownerUser: null });
      setError(requestError?.response?.data?.error || requestError?.response?.data?.msg || "Assigned notifications load nahi ho sakin.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" flexWrap="wrap" sx={{ p: 2.25 }}>
          <Stack direction="row" spacing={1.25} alignItems="center">
            <NotificationsNoneIcon color="primary" />
            <Box>
              <Typography fontWeight={800}>My Notifications</Typography>
              <Typography variant="body2" color="text.secondary">Aapko assign hue alert templates aur channels.</Typography>
              {meta.ownerUser?.username ? <Typography variant="caption" color="text.secondary">Managed by {meta.ownerUser.username}</Typography> : null}
            </Box>
          </Stack>
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Chip size="small" label={`${alerts.length} alerts`} variant="outlined" />
            <Chip size="small" label={`${meta.deviceCount} vehicles`} variant="outlined" />
            <Chip size="small" label={`${activeCount} active`} color={activeCount ? "success" : "default"} />
            <IconButton aria-label="Refresh notifications" onClick={load}><RefreshIcon /></IconButton>
          </Stack>
        </Stack>
        <Box sx={{ p: 2.25, borderTop: "1px solid", borderColor: "divider" }}>
          {loading ? <Box textAlign="center" py={3}><CircularProgress size={26} /></Box> : null}
          {!loading && error ? <Alert severity="error">{error}</Alert> : null}
          {!loading && !error && !alerts.length ? <Alert severity="info">Koi assigned alert template nahi mila.</Alert> : null}
          {!loading && !error ? <Stack spacing={1}>{alerts.map((alert) => (
            <Paper key={alert?.key || alert?.alarmType || alert?.label} variant="outlined" sx={{ p: 1.5, borderRadius: 2, bgcolor: alert?.checked === false ? "#fff" : "#f8fbff" }}>
              <Stack direction="row" justifyContent="space-between" gap={1} flexWrap="wrap">
                <Box><Typography fontWeight={800}>{alert?.label || alert?.alarmType || "Notification"}</Typography><Typography variant="body2" color="text.secondary">Channel: {Array.isArray(alert?.channels) && alert.channels.length ? alert.channels.join(", ") : "web"} • Sound: {alert?.sound || "default"} • Priority: {alert?.priority || "medium"}</Typography></Box>
                <Chip size="small" label={alert?.checked === false ? "Off" : "Assigned"} color={alert?.checked === false ? "default" : "success"} />
              </Stack>
            </Paper>
          ))}</Stack> : null}
        </Box>
      </Paper>
    </Box>
  );
}
